import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";
import {AgentModel} from "../../angular/models/agent.model";
import {$agentFactory} from "../../$agent.factory";

export class AgentListItemCtrl implements IController {

  agentId: string;
  isMultiple: any;
  isSelected: any;
  excludeIds: any;
  showLink: any;

  onAdd: Function;
  onToggle: Function;

  private agent: AgentModel;

  constructor(private $agent: $agentFactory, private $scope: IScope) {
  }

  $onInit() {
    if (!this.excludeIds) {
      this.excludeIds = [];
    }
    if (this.agentId) {
      this.$agent(this.agentId).$bindCtrlToId(this.$scope, this, 'agent', 'agentId');
    }
  }

  $onChanges(changes) {
    if (changes.agentId && !changes.agentId.isFirstChange()) {
      this.$onInit();
    }
  };

  showAdd() {
    return _.isFunction(this.onAdd) && !this.isMultiple;
  }

  getDisabledValue() {
    if (!this.agent) {
      return true;
    }
    return _.findIndex(this.excludeIds, (id) => {
      return this.agent.id === id;
    }) !== -1;
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentListItem', {
    bindings: {
      agentId: '<',
      isMultiple: '<?',
      isSelected: '<?',
      excludeIds: '<?',
      showLink: '<?',
      onAdd: '&?',
      onToggle: '&'
    },
    template: require('./agent-list-item.html').default,
    controller: AgentListItemCtrl
  });
